// @ts-check

import {GRANITE_10} from '@gaia/colors';
import {gaiaSimpleWhite, profileAvatar} from '@gaia/icons';
import {Avatar} from '@mui/material';

/**
 * @typedef BadgeProps
 * @prop {boolean} staff
 * @prop {boolean} ranger
 *
 * @param {BadgeProps} props
 */
function Badge(props) {
    const avatarBadgeStyle = {
        top: '30px',
        left: '30px',
        height: '18px',
        width: '18px',
        borderRadius: '100%',
        borderStyle: 'none',
        position: 'absolute',
        backgroundColor: 'white',
        color: '#34573C',
        fontSize: '16px',
    };
    const staffBadgeStyle = {
        backgroundColor: '#34573C',
        padding: 1,
    };

    if (props.staff) {
        return (
            <img
                alt='Gaia Staff'
                // @ts-ignore
                style={{...avatarBadgeStyle, ...staffBadgeStyle}}
                // @ts-ignore
                src={gaiaSimpleWhite}
            />
        );
    } else if (props.ranger) {
        return (
            <i
                // @ts-ignore
                style={avatarBadgeStyle}
                className='material-icons'
            >
                stars
            </i>
        );
    } else {
        return null;
    }
}

/**
 * @typedef UserAvatarProps
 * @prop {string | number | null} id
 * @prop {string} [name]
 * @prop {string | null} image
 * @prop {boolean} staff
 * @prop {boolean} ranger
 *
 * @param {UserAvatarProps} props
 */
export function UserAvatar(props) {
    // need a fallback for when the user doesn't have a profile image
    const image = props.image ?? profileAvatar;

    return (
        <div
            style={{
                borderRadius: '100%',
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'middle',
                backgroundColor: GRANITE_10,
            }}
        >
            <Avatar
                data-userid={`${props.id ?? 0}`}
                alt={props.name}
                style={{
                    width: `40px`,
                    height: `40px`,
                    borderRadius: '100%',
                    border: `3px solid white`,
                }}
                src={image}
            />
            <Badge {...props} />
        </div>
    );
}
